import { ChangeDetectionStrategy, Component, Optional } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsOutletComponent } from '@icms/client/assets/outlet/icms-outlet.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { Product } from '../product.decorator';
import { ProductRangeBannerComponent } from './product-range-banner.component';

@Component({
    selector: 'product-range-banner-wrapper',
    templateUrl: 'product-range-banner-wrapper.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ProductRangeBannerComponent]
})
@ICmsComponent<ProductRangeBannerWrapperComponent>({
    id: 'product-range-banner-wrapper',
    name: 'Prodct range banner Wrapper',
    tags: ['Product', 'Range', 'Banner'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label',
            title: 'Please edit content block inside this component'
        }
    ]
})
export class ProductRangeBannerWrapperComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NICmsContentComponent.IData;

    constructor(
        @Optional() public outlet: ICmsOutletComponent
    ) {
        super();
    }

    outletOptions?: {
        context: Product<IProductDataV3>;
    };

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.outlet?.optionsChange.subscribe(() => this.detectChanges()));
    }

    get product(): Product<IProductDataV3> | undefined {
        return this.outletOptions?.context;
    }
}
